<div class="footer">
    <div class="d-flex mobile-res ">
        <div class="footer-logo" >
            <a routerLink="/home">

                <img src="assets/images/taly-footer-logo.svg" alt="Footer logo">
            </a>
        </div>
        <ul class="socila-media">
            <li *ngFor=" let account of socialMedia;">
                <a [href]="account?.link" target="_blank">
                    <img [src]="account?.icon" alt="{{account?.name}}">
                </a>
            </li>
        </ul>
        <div class="language-icon">

            <div class="language" (click)="toggleText()">
                <img src="assets/images/footer-white-logo.svg" alt="">
                <label for="lang" translate> LANGUAGE</label>
            </div>
        </div>
    </div>
    <div class="d-flex download-app-link">
        <div class="app-store">
            <h4 translate>FOOTER.DOWNLOAD</h4>
            <a [href]="appLink" target="_blank"> <img [src]="appIcon" alt="QR Code"> </a>
        </div>
    </div>
    <div class="d-flex list-item ">

        <ul>
            <li><a translate>FOOTER.SHOPERS</a></li>
            <li><a routerLink="/faq-shopper" translate>FOOTER.FAQ</a></li>

            <!-- [TODO] : as requested on 24 May 2025 from sulaiman we are hiding temparary later will enable, so dont delete this code -->
            <!-- <li><a routerLink="/shops" translate>FOOTER.SHOPS</a></li> -->
            <li><a routerLink="/terms-and-conditions" translate>FOOTER.TERMS</a></li>

        </ul>
        <ul>
            <li><a translate>FOOTER.PARTNERS</a></li>
            <li><a routerLink="/partners/sign-up" translate>FOOTER.SIGNUP</a></li>
            <li><a routerLink="/faq-partner" translate>FOOTER.FAQ</a></li>            
            <li><a [href]="envService?.MerchantURL" target="_blank" translate>FOOTER.PARTNER_PORTAL </a></li>
            <li><a [href]="envService?.DocsURL" target="_blank" translate>FOOTER.DEVELOPER </a></li>
        

        </ul>
        <ul>
            <li> <a translate>FOOTER.ABOUT</a></li>
            <li><a href="assets/docs/sharia-compliant.pdf" target="_blank" translate>FOOTER.SHARIA</a></li>
            <li><a [href]="envService?.CareerURL" target="_blank" translate>FOOTER.CARRIES</a></li>
            <li><a routerLink="/press" translate>FOOTER.PRESS</a></li>
        </ul>
        <div class="qr-code" id="targetAppDownload">
            <div>
                <a [href]="appLink" target="_blank">
                    <img src="assets/images/qr-code.svg" class="cursor" alt="qr-code">
                </a>
            </div>
            <div>
                <h4 translate>FOOTER.DOWNLOAD</h4>
                <span translate>FOOTER.SCAN</span>
            </div>
        </div>
    </div>
    <hr>
    <div class="d-flex bottom-header">
        <div class="language-button" (click)="toggleText()">

            <div class="language" >
                <img src="assets/images/footer-white-logo.svg" alt="">
                <label for="lang" translate> LANGUAGE</label>
            </div>
        </div>

        <ul>
            <li *ngFor="let type of paymentPartners">
                <img [src]="type.icon" [alt]="type.name">
            </li>
        </ul>
        <div class="copy-right">
            <ul>
                <!-- <li><a routerLink="/terms-and-conditions" translate>FOOTER.TERMS</a></li> -->
                <li><a routerLink="/privacy-policy" translate>FOOTER.PRIVACY</a></li>
                <li><a translate [translateParams]="{year: currentYear}"> FOOTER.COPY_RIGHT</a></li>
                <!-- [translateParams]="{ currentYear : currentYear}" -->
            </ul>
        </div>
    </div>
</div>